<template>
  <div>
    <slot name="prefix" />
    <v-row>
      <template>
        <div class="row mx-0">
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="locale.socialIdType"
              :value.sync="formModel.socialIdType"
              :items="identityTypes"
              item-text="name"
              item-value="id"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :key="formKey"
              :form-key="formKey"
              :type-id="formFieldType.text"
              :label="locale.socialId"
              :value.sync="formModel.socialId"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="12"
            lg="6"
          >
            <naj-input
              :form-key="formKey"
              :technical-name="formKey"
              :label="locale.birthDate"
              :type-id="formFieldType.date"
              :value.sync="formModel.dateOfBirth"
              :disabled="true"
            ></naj-input>
          </v-col>
        </div>

        <div class="row mx-0">
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :key="formKey"
              :form-key="formKey"
              :type-id="formFieldType.text"
              :label="locale.firstName"
              :value.sync="formModel.firstName"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.fatherName"
              :value.sync="formModel.fatherName"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            :lg="viewMode ? 3 : 2"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.thirdName"
              :value.sync="formModel.grandFatherName"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            :lg="viewMode ? 3 : 2"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.familyName"
              :value.sync="formModel.familyName"
              :disabled="true"
            ></naj-input>
          </v-col>
        </div>
      </template>
    </v-row>
    <v-row>
      <v-col
        md="6"
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="locale.nationality"
          :value.sync="formModel.nationalityCountryId"
          :items="countries"
          item-text="name"
          item-value="id"
          :disabled="true"
        ></naj-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { uuidGenerator } from '@/helpers/utils';
import { socialIdentityTypeEnum } from '@/helpers/enum';
const { mapState: mapLUTState, mapActions } = createNamespacedHelpers('LookupsModule');

export default {
  name: 'OriginalApplicantForm',
  inject: ['$validator'],
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    viewMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    isOptional: {
      type: Boolean,
      required: false,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      formKey: uuidGenerator(),
      locale: this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.requestApplicant,
      socialIdentityTypeEnum,
      identityTypes: [],
    };
  },
  computed: { ...mapLUTState(['countries']) },
  created() {
    this.getCountries();
  },
  mounted() {
    this.socialId = this.formModel.socialId;
    let socialTypes = {
      nationalId: 1,
      regularResidency: 2,
    };
    this.identityTypes = Object.keys(socialTypes).map(pt => ({
      id: socialIdentityTypeEnum[pt],
      name: this.local.bankruptcy.common[pt],
    }));
  },
  methods: { ...mapActions(['getCountries']) },
};
</script>

<style lang="scss" scoped></style>
